var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Criterion: " + _vm._s(_vm.criterionName)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "form",
                    {
                      attrs: { id: "criterion-scale-editor-form" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.emitAssignCustomScale.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _c("p", { staticClass: "lead" }, [
                        _vm._v(_vm._s(_vm.criterionDescription)),
                      ]),
                      _vm._v(" "),
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        _vm._l(_vm.levels, function (sl) {
                          return _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: { "margin-bottom": "5px" },
                            },
                            [
                              _c("div", { staticClass: "col-sm-3" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: sl.Name,
                                      expression: "sl.Name",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    required: "",
                                    maxlength: "100",
                                    placeholder: "Level",
                                  },
                                  domProps: { value: sl.Name },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        sl,
                                        "Name",
                                        $event.target.value.trim()
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-2" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.number",
                                      value: sl.Value,
                                      expression: "sl.Value",
                                      modifiers: { number: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "number",
                                    placeholder: "Number...",
                                    required: "",
                                    min: "0",
                                    step: "any",
                                  },
                                  domProps: { value: sl.Value },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        sl,
                                        "Value",
                                        _vm._n($event.target.value)
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-6" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: sl.Definition,
                                      expression: "sl.Definition",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Definition for level",
                                  },
                                  domProps: { value: sl.Definition },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        sl,
                                        "Definition",
                                        $event.target.value.trim()
                                      )
                                    },
                                    blur: function ($event) {
                                      return _vm.$forceUpdate()
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-1" }, [
                                _c("a", {
                                  staticClass: "pointer fa fa-times",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteLevel(sl)
                                    },
                                  },
                                }),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "error" }, [
                        _vm._v(_vm._s(_vm.error)),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _c(
                          "a",
                          {
                            staticClass: "text-primary",
                            on: { click: _vm.addLevel },
                          },
                          [_vm._v("Add scale level")]
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "submit",
                        form: "criterion-scale-editor-form",
                      },
                    },
                    [_vm._v("Update")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "row", staticStyle: { "margin-bottom": "5px" } },
      [
        _c("div", { staticClass: "col-sm-3" }, [
          _c("label", [
            _vm._v("Scale level "),
            _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-2" }, [
          _c("label", [
            _vm._v("Value "),
            _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6" }, [
          _c("label", [_vm._v("Definition")]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }